<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Sorteio Auditoral Notas Fiscais.</span>
                <br/>
                <span class="navigation">Nota Fiscal > Sorteio</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form name="form" >
            <div class="row">
              <div class="col-md-2 col-lg-2 mb-1">
                <label for="compIni">Competência: *</label>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2 col-lg-2 mb-3">
                <span class="p-fluid">
                  <InputMask
                    v-model="comp"
                    id="compIni"
                    mask="9999/99"
                    placeholder="Competência"
                  />
                </span>
              </div>
            </div>
            
            <div class="row col-6 col-md-3 mb-3">
              <Button
                label="Sortear"
                title="Sortear"
                type="submit"
                class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check"
                :disabled="loading"
                @click="realizarSorteio()"
              >
              </Button>
            </div>
          </form>
          <hr />
          <div style="margin-top: 20px"></div>
          <TabView>
            <TabPanel header="Notas Fiscais Sorteadas">
              <DataTable
                style="min-width: 880px"
                :value="sorteiosList"
                :paginator="true"
                :rows="4"
                class="p-datatable-responsive"
                :autoLayout="true"
                :filters="filtersModel"
              >
                <Column headerStyle="width: 12em" bodyStyle="text-align: center">
                  <template #body="slotProps">
                    <Button
                      type="button"
                      icon="pi pi-print"
                      style="margin-right: .5em"
                      @click="visualizar(slotProps.data.idNotaFiscal)"
                    >
                    </Button>
                  </template>
                </Column>
                <Column field="dataSorteioFormatada" header="Data Sorteio">
                  <template #filter>
                    <InputText
                      type="text"
                      v-model="filtersModel['dataSorteioFormatada']"
                      class="p-column-filter"
                      placeholder="Filtrar por data"
                      style="width: 10em"
                    />
                  </template>
                </Column>
                <Column field="competenciaFormatada" header="Competência">
                  <template #filter>
                    <InputText
                      type="text"
                      v-model="filtersModel['competenciaFormatada']"
                      class="p-column-filter"
                      placeholder="Filtrar por competência"
                      style="width: 10em"
                    />
                  </template>
                </Column>
                <Column field="codigoVerificacaoNota" header="Código Verificação Nota Fiscal Sorteada">
                  <template #filter>
                    <InputText
                      type="text"
                      v-model="filtersModel['codigoVerificacaoNota']"
                      class="p-column-filter"
                      placeholder="Filtrar por código"
                      style="width: 10em"
                    />
                  </template>
                </Column>
              </DataTable>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </div>
    <Dialog
      class="sorteio-dialog"
      header="Nota Fiscal Sorteada"
      :visible.sync="dialogVisible"
      :modal="true"
      :closable="false"
    >
      <div class="dialog-content">
        <p class="verification-label">O código de verificação da Nota Fiscal sorteada é:</p>
        <h2 class="verification-code">{{ codigoVerificacao }}</h2>
      </div>

      <div class="dialog-footer">
        <Button
          label="Imprimir"
          icon="pi pi-print"
          class="p-button-primary"
          @click="visualizar(idNotaFiscal)"
        />
        <Button
          label="Fechar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="closeDialogSorteio()"
        />
      </div>
    </Dialog>
  </div>
</template>

<script>
import LoginService from "../services/acesso/login.service";
import NotaFiscalService from "../services/nfse/notafiscal.service";
import ReportService from "../services/report.service";

export default {
  name: "sorteioAuditoralNfse",
  data() {
    return {
      currentUser: null,
      loading: false,
      comp: "",
      dataAtual: null,
      dialogVisible: false,
      codigoVerificacao: "",
      sorteiosList: [],
      idNotaFiscal: null,
      filtersModel: {
        dataSorteioFormatada: '',
        competenciaFormatada: '',
        codigoVerificacaoNota: '',
      },
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.dataAtual = new Date();
    this.carregarCompetenciaAtual();
    this.pesquisar();
  },
  methods: {
    carregarCompetenciaAtual() {
      const ano = this.dataAtual.getFullYear();
      const mes = this.dataAtual.getMonth() + 1;

    this.comp = `${ano}/${mes.toString().padStart(2, "0")}`;
    },
    realizarSorteio() {
      const [ano, mes] = this.comp.split("/");
      this.processando(true);
      NotaFiscalService.realizarSorteio(ano, mes).then(
        response => {
          
          console.log(response.data);
          const notaSorteada = response.data;
          this.codigoVerificacao = notaSorteada.codigoVerificacao;
          this.openDialogSorteio(notaSorteada.id);
          NotaFiscalService.salvarSorteio(
            notaSorteada.id,
            ano,
            mes
          ).then(
            response =>{
              console.log(response.data);
            },
            error =>{
              let errorMessage = "Houve um problema ao Salvar o sorteio Realizado!";
              if (error.response) {
                errorMessage = error.response.data;
              }
              this.$toast.add({
                severity: "error",
                summary: errorMessage
              });
            }
          )
          this.$toast.add({
            severity: "success",
            summary: "Sorteio realizado com sucesso!",
            life: 5000
          });
          this.pesquisar();
          this.processando(false);
        },
        error => {
          this.processando(false);
          let errorMessage = "Houve um problema ao realizar o sorteio!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage,
            life: 8000
          });
        }
      );
    },
    pesquisar(){
      NotaFiscalService.findSorteiosNfse()
      .then(
        response =>{
          console.log(response.data);
          this.sorteiosList = response.data;
        },
        error =>{
          let errorMessage = "Houve um problema ao buscar os sorteios realizados!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      )
    },
    visualizar(nfseId) {
      this.processando(true);

      let nomeRel = (this.observacaoClienteNfse ? "NotaFiscalEletronicaObs" : "NotaFiscalEletronica");

      ReportService.imprimir(nomeRel, [
        {
          param: "where",
          string: " and nota_fiscal.id = '" + nfseId + "' ",
        }

      ])
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    openDialogSorteio(idNota){
      this.dialogVisible = true;
      this.idNotaFiscal = idNota;
      console.log("ID DA NOTA: "+this.idNotaFiscal);
    },
    closeDialogSorteio(){
      this.dialogVisible = false;
      this.pesquisar();
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
  }
};
</script>

<style scoped>
  .sorteio-dialog {
    width: 100%;
    max-width: none;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .dialog-content {
    background-color: #fff;
    border-radius: 10px;
    text-align: center;
    padding: 30px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    width: 400px;
    max-width: 90%;
    margin: 0 auto;
  }

  .verification-label {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
    border-bottom: 2px solid #ddd;
    display: inline-block;
    padding-bottom: 5px;
  }

  .verification-code {
    font-size: 24px;
    color: #0056b3;
    font-weight: 600;
    margin-top: 15px;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
  }
</style>
